// Agent display name hook — fetches the identity name from /api/agent.
import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export function useAgentName(): string {
  const query = useQuery({
    queryKey: ['agent-name'],
    queryFn: async () => {
      const res = await api<{ name?: string }>('/api/agent');
      return res.name ?? 'Agent';
    },
    staleTime: 300_000,
  });
  return query.data ?? 'Agent';
}
